// Dependencies
import { FC } from 'react';
import { Table, TableBody, TableCell, TableRow } from '@mui/material';

// Interfaces
interface IDataTableProps {
  data: object;
}

// Export Table component
export const DataTable: FC<IDataTableProps> = ({ data = {} }) => {
  // Return Table component
  return (
    <Table>
      <TableBody>
        {Object.entries(data).map(([key, value], index) => {
          const displayValue = value === undefined || value === null ? '' : String(value);
          const multiline = displayValue.includes('\n');
          const cellHeight = multiline ? 'auto !important' : '20px !important';
          return (
            <TableRow key={index} sx={{ '&:hover': { '.MuiTableCell-body': { background: 'transparent !important' } } }}>
              <TableCell
                sx={{
                  fontSize: '14px !important',
                  color: '#808080 !important',
                  height: cellHeight,
                  minHeight: '20px',
                  paddingLeft: '0 !important',
                  verticalAlign: 'top',
                }}
              >
                {key}:
              </TableCell>
              <TableCell
                sx={{
                  fontSize: '14px !important',
                  color: '#000000 !important',
                  height: cellHeight,
                  minHeight: '20px',
                  whiteSpace: multiline ? 'pre-wrap' : 'normal',
                  verticalAlign: 'top',
                }}
              >
                {displayValue}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};
